import type { TInterview } from '@/services/interviews';

const isInterviewPast = (interviewStartsAt: string | null): boolean => {
  if (!interviewStartsAt) {
    return false;
  }

  return new Date(interviewStartsAt).getTime() <= Date.now();
};

const isBookedInterview = (interview: TInterview): boolean => interview.canceledAt === null && interview.noShowAt === null;

const isLiveInterview = (interview: TInterview): boolean => isBookedInterview(interview) && interview.completedAt === null;

const toBookedInterview = (interviews: readonly TInterview[] | undefined): TInterview | null => interviews?.find(isBookedInterview) ?? null;

const toLiveInterview = (interviews: readonly TInterview[] | undefined): TInterview | null => interviews?.find(isLiveInterview) ?? null;

const toAttemptsLabel = (attempts: number, limit: number): string => `${attempts} of ${limit}`;

export {
  isBookedInterview,
  isInterviewPast,
  isLiveInterview,
  toAttemptsLabel,
  toBookedInterview,
  toLiveInterview,
};
